import type { SiteContent } from '../content/types';
import { Container } from '../components/layout/container';
import { PageHero } from '../components/sections/page-hero';
import { FaqAccordion } from '../components/sections/faq-accordion';
import { Card, CardContent } from '../components/ui/card';

interface FaqPageProps {
  content: SiteContent;
}

export function FaqPage({ content }: FaqPageProps): JSX.Element {
  return (
    <>
      <PageHero title={content.faqSection.headline} />
      <section className="pb-12 sm:pb-16">
        <Container>
          <Card className="bg-white">
            <CardContent className="p-6">
              <FaqAccordion items={content.faqSection.items} />
            </CardContent>
          </Card>
        </Container>
      </section>
    </>
  );
}
